import { render } from "./AlertBoxR.vue?vue&type=template&id=3bbe5a47&scoped=true"
import script from "./AlertBoxR.vue?vue&type=script&lang=js"
export * from "./AlertBoxR.vue?vue&type=script&lang=js"

import "./AlertBoxR.vue?vue&type=style&index=0&id=3bbe5a47&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbe5a47"]])

export default __exports__